import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';

import { JsonObject } from '@angular-devkit/core';
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { CommonService } from "../../../_common/_service/user.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';

@Component({
  selector: 'app-pay-money',
  templateUrl: './pay-money.component.html',
  styleUrls: ['./pay-money.component.scss']
})
export class PayMoneyComponent implements OnInit {

  countryList: any;
  serviceList: any;
  operatorList: any;
  productList: any;

  IsDataGet = false;
  IsOprtDataGet = false;
  isGetproductList = false;
  recentReceiver: any;
  submitted = false;

  balance: any;
  public payMoneyForm: FormGroup;
  stringJson: any;
  stringObject: any;
  UsertBal: any;
  countryCode: any;
  channelList: any;
  userorderdetailList: any;
  ServiceName: any;
  
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  serviceCode: any;
  countryIsdcode: any;
  loadingspinner: boolean = false;

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();

  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {

    this.countryIsdcode = localStorage.getItem('countryIsdcode');

    this.payMoneyForm = this.fb.group({
      ISD: [null, [Validators.required]],
      Amount: [null, [Validators.required]],
      MobileMoneySource: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(8)]],
      Comment: [null],
      BeneficiaryName: [null, [Validators.pattern("^[a-zA-Z ]*$")]],
      PaymentModeCode: ["RRP"],

      ServiceCode: [null],
      DeviceType: "web"

    })
    this.f.Amount.valueChanges.subscribe(val => {
      if (val == "") {
        this.commissionFee = 0;
        this.commissionTotal = 0;

      }

      if (val && val.length > 0) {

        if (this.serviceCode && this.f.PaymentModeCode.value) {

          this.getServiceCommissionList(this.f.Amount.value, this.f.PaymentModeCode.value, this.serviceCode);
        }
        // for optin 1 popup :- AccountCodeFrom,form :- AccountCode
        //else if ((this.f.PaymentModeCode.value && this.f.AccountCode.value && this.f.AccountCodeFrom.value) && this.show == 1) {
        //  this.getServiceCommissionList(this.f.Amount.value, this.f.AccountCode.value, this.f.AccountCodeFrom.value);
        //}
        else {
          this.toastr.error("Selected Proper Option", 'Error');
        }
        // Amount= ; AddService_Code=; PayService_Code= 
      }
    });
  }
  ngOnInit() {
    
    this.token = this.tokenStorageService.getToken();
     this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {

      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();
      this.getcountryList();
      this.viewTransactions();

      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });
    }
    else {
      this._service.callMethodOfSecondComponent();
    }


  }
  get f() { return this.payMoneyForm.controls; }

  Back() {

    this.router.navigate(['/Go-on']);
  }




  getcountryList() {
    this.submitted = true;

    this.authService.getIsdCode().subscribe(response => {

      if (response) {
        this.countryList = response;
        // this.toastr.successToastr(response.Message, AppConstant.success);
      } else {
        this.toastr.error(response, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }
  filterCountry() {

    if (this.CountryFilterCtrl.value) {
      //  
      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }



  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {
    debugger;
    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
      debugger;
      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;


        ////////console.log(this.commissionList);
        ////////console.log(this.commissionFee);
        ////////console.log(this.commissionTotal);

        // this.toastr.successToastr(response.Message, AppConstant.success);
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }




  payMoney(post: any) {
    

    this.submitted = true;

    //if (post.Amount == null || post.Amount == 'undefined' || this.amt == null || this.amt == 'undefined') {

    //  this.toastr.error("Error Occur Refresh Page", 'Error');

    //}

    //else {
      if (this.payMoneyForm.valid) {
        this.loadingspinner = true; 
        var serviceReq = null;

        ////form 
        //serviceReq = {
        //  //countryCode: post.ISD,
        //  mobileno: post.ISD + post.MobileMoneySource,

        //  amount: parseFloat(post.Amount),
        //  accountcode: this.serviceCode,
        //  beneficiary: post.BeneficiaryName,
        //  comment: post.Comment
        //}

        ////
        //var post1 = {
        //  //form
        //  serviceReq: JSON.stringify(serviceReq),
        //  serviceCode: this.serviceCode,
        //  paymentModeCode: this.f.PaymentModeCode.value,

        //  deviceType: "web"
        //}

         serviceReq = {
          //countryCode: post.ISD,
          api_key: "7d38a1c8-8d43-427c-8eb9-8c54221a56e3",
          mobileno: post.ISD + post.MobileMoneySource,

          amount: parseFloat(post.Amount),
           accountcode: "GBO",
          beneficiary: post.BeneficiaryName,
          comment: post.Comment
        }
        this.stringJson = JSON.stringify(serviceReq);
        
        debugger
        this.authService.payMoney(this.stringJson, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
          
          this.loadingspinner = false; 
          if (response.apiStatus == true && response.apiData.transactionStatus == 2) {
          
            this.data = response.apiData;
            ////////console.log("data succ response -", this.data);
            this.openPaymentConfirmDialog(this.data);

            this.submitted = false;
            this.f.Comment.setValue(null);
            this.f.BeneficiaryName.setValue(null);
            this.f.MobileMoneySource.setValue(null);

            this.f.Amount.setValue(null);

            this.commissionFee = 0;
            this.commissionTotal = 0;
            this.tokenService.updateMessagetoken('token');

          }
          //else if (response.apiStatus == true && response.apiData.transactionStatus != 2) {
          //  this.submitted = false;
          //  this.f.Comment.setValue(null);
          //  this.f.BeneficiaryName.setValue(null);
          //  this.f.MobileMoneySource.setValue(null);

          //  this.f.Amount.setValue(null);

          //  this.commissionFee = 0;
          //  this.commissionTotal = 0;
          //  this.tokenService.updateMessagetoken('token');

          //  this.toastr.error(response.apiMessage, 'Error');
          //}
          else {
            this.toastr.error(response.apiMessage, 'Error');
          }
        }, (err: any) => {
            this.loadingspinner = false; 
          if (err.error instanceof Error) {

            this.toastr.error(err.error, 'Error');
          } else {

            this.toastr.error(err.error, 'Error');
          }
        }
        );
      }
    //}

  }

  openPaymentConfirmDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });

  }




  viewTransactions() {

    this.authService.getUserOrdersdetails1(this.serviceCode, this.currentUser.serviceid).subscribe(response => {
      ;
      if (response.apiStatus == true) {
        this.userorderdetailList = response.apiData;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }




}
